"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ControllableWave = void 0;

var _react = _interopRequireDefault(require("react"));

var _MouseTransformHandler = _interopRequireDefault(require("../MouseTransformHandler"));

var _immutableTransformMatrix = _interopRequireDefault(require("immutable-transform-matrix"));

var _Wave = _interopRequireDefault(require("../Wave"));

var _useEventCallback = _interopRequireDefault(require("use-event-callback"));

var _useRafState3 = _interopRequireDefault(require("react-use/lib/useRafState"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ControllableWave = function ControllableWave(_ref) {
  var curves = _ref.curves,
      topLevelMatrix = _ref.topLevelMatrix,
      setTopLevelMatrix = _ref.setTopLevelMatrix,
      width = _ref.width,
      height = _ref.height,
      onDragDuration = _ref.onDragDuration,
      onDragDurationStart = _ref.onDragDurationStart,
      onDragDurationEnd = _ref.onDragDurationEnd,
      onCreateTimestamp = _ref.onCreateTimestamp,
      durationGroups = _ref.durationGroups,
      timestamps = _ref.timestamps,
      gridLineMetrics = _ref.gridLineMetrics,
      timeFormat = _ref.timeFormat,
      showValues = _ref.showValues;

  var _useRafState = (0, _useRafState3.default)(function () {
    var mat = new _immutableTransformMatrix.default();
    var maxY = Math.max.apply(Math, _toConsumableArray(curves[0].data.map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          y = _ref3[1];

      return y;
    })));
    var minY = Math.min.apply(Math, _toConsumableArray(curves[0].data.map(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
          y = _ref5[1];

      return y;
    })));
    return mat.scale(1, -1).scale(1, height).scale(1, 1 / (maxY - minY)).translate(0, -maxY);
  }),
      _useRafState2 = _slicedToArray(_useRafState, 2),
      matrix = _useRafState2[0],
      setMatrix = _useRafState2[1];

  matrix = matrix.set("a", topLevelMatrix.get("a")).set("e", topLevelMatrix.get("e"));
  var onChangeMatrix = (0, _useEventCallback.default)(function (newMatrix) {
    setMatrix(newMatrix);
    setTopLevelMatrix(topLevelMatrix.set("a", newMatrix.get("a")).set("e", newMatrix.get("e")));
  });
  return /*#__PURE__*/_react.default.createElement(_MouseTransformHandler.default, {
    matrix: matrix,
    onChangeMatrix: onChangeMatrix,
    onDragDuration: onDragDuration,
    onDragDurationStart: onDragDurationStart,
    onDragDurationEnd: onDragDurationEnd,
    onCreateTimestamp: onCreateTimestamp
  }, /*#__PURE__*/_react.default.createElement(_Wave.default, {
    curves: curves,
    width: width,
    height: height,
    timeFormat: timeFormat,
    transformMatrix: matrix,
    gridLineMetrics: gridLineMetrics,
    timestamps: timestamps,
    durationGroups: durationGroups,
    showValues: showValues
  }));
};

exports.ControllableWave = ControllableWave;
var _default = ControllableWave;
exports.default = _default;